import React, { useEffect, useState } from 'react';

// Utility function to preload a single image
const preloadImage = (src) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = () => resolve(src);
        img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
    });
};

// Utility function to preload multiple images
export const preloadImages = async (srcs) => {
    try {
        const promises = srcs.map(preloadImage);
        await Promise.all(promises);
        return true;
    } catch (error) {
        console.error('Image preloading failed:', error);
        return false;
    }
};

// React component to handle preloading
export const ImagePreloader = ({ children, onComplete }) => {
    const [imagesLoaded, setImagesLoaded] = useState(false);

    useEffect(() => {
        const gifUrls = Array.from({ length: 5 }, (_, i) => `/concepts/${i + 1}.gif`);

        const loadImages = async () => {
            const success = await preloadImages(gifUrls);
            setImagesLoaded(true);
            if (onComplete) {
                onComplete(success);
            }
        };

        loadImages();
    }, [onComplete]);

    if (!imagesLoaded) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-primary mx-auto"></div>
                    <p className="mt-4 text-primary">Loading assets...</p>
                </div>
            </div>
        );
    }

    return children;
};

export default ImagePreloader;